export default {
  apiKey: "AIzaSyAXVSbJ4kbYU6DaaoerRIU2iYMP0D9R1sc",
  authDomain: "inreach-31c07.firebaseapp.com",
  databaseURL: "https://inreach-31c07.firebaseio.com",
  projectId: "inreach-31c07",
  storageBucket: "",
  messagingSenderId: "585450682091",
  appId: "1:585450682091:web:f9f9a59bc1acbfab"
};